import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
const deprecationWarning = (componentName, migrationInstructions) => {
  if (process.env.NODE_ENV !== 'production') {
    const fullMitigationInstructions = migrationInstructions ? `To update:\n${migrationInstructions}` : '';
    // eslint-disable-next-line no-console
    console.warn(`%c${componentName} is deprecated & will be removed in the next major release of sales-ui. ${fullMitigationInstructions}`, 'color: #D43900;');
  }
};
const nodeToText = node => {
  if (['string', 'number'].includes(typeof node)) {
    return node;
  }
  if (node instanceof Array) {
    return node.map(nodeToText).join('');
  }
  if (typeof node === 'object' && node && 'props' in node) {
    return nodeToText(node.props.children);
  }
  return node;
};
function progressbarHasAccessibleName(props, propName, componentName) {
  // eslint-disable-next-line react/destructuring-assignment
  if (!props['aria-label'] && !props['aria-labelledby'] && !props.title) {
    return new Error(`${componentName} requires an accessible name. Please provide a value for either "aria-label", "aria-labelledby", or "title".`);
  }
  return null;
}
export { deprecationWarning, nodeToText, progressbarHasAccessibleName };